import { EOrderExpiry, EOrderIndicate, EOrderType } from '@webtrader/core/api/order';
import { ETradeFillPolicy } from '@webtrader/core/api/trade/index';
import request from '@webtrader/core/request';

export type TLimitTradeOrderType =
  | EOrderType.BUY_LIMIT
  | EOrderType.SELL_LIMIT
  | EOrderType.BUY_STOP
  | EOrderType.SELL_STOP
  | EOrderType.BUY_STOP_LIMIT
  | EOrderType.SELL_STOP_LIMIT;

export interface ICreateLimitTradeParams {
  orderType: TLimitTradeOrderType;
  symbol: string;
  lotSize: number;
  price: number;
  tradeExpiry: EOrderExpiry;
  indicate?: EOrderIndicate;
  stopLoss?: number;
  takeProfit?: number;
  fillPolicy?: ETradeFillPolicy;
  expiration?: number;
  priceTrigger?: number;
  units?: string;
  centroidDeviation?: number;
}

export interface IUpdateLimitTradeParams
  extends Pick<
    ICreateLimitTradeParams,
    | 'symbol'
    | 'price'
    | 'tradeExpiry'
    | 'indicate'
    | 'stopLoss'
    | 'takeProfit'
    | 'expiration'
    | 'priceTrigger'
    | 'units'
    | 'centroidDeviation'
  > {
  orderId: string;
}

export default {
  create: (params: ICreateLimitTradeParams) => request.post<boolean>('/api/trade/v2/limit', params),
  update: (params: IUpdateLimitTradeParams) => request.patch<boolean>('/api/trade/v2/limit', params)
};
